export const additionalChargesTab = {
  loading: "Wczytywanie ustawień…",
  tax: {
    title: "Podatek (VAT)",
    tag: "Wliczony w cenę",
    description:
      "VAT jest już <b>wliczony</b> w ceny taryf. Tutaj ustala się tylko, jaki procent zostanie wykazany na paragonie i fakturze; <b>nie jest on doliczany do sumy</b>.",
    hint: "Puste = stosowany jest VAT przypisanego wystawcy faktur. Dotyczy tylko rezerwacji bezpośrednich.",
  },
  cleaning: {
    title: "Opłata za sprzątanie",
    tag: "Stała",
    description: "Stała kwota za pobyt. Jeśli <b>0</b>, nie jest naliczana.",
    showToGuest: "Pokaż w podsumowaniu rezerwacji",
  },
  charges: {
    title: "Opłaty dodatkowe",
    summary: "Skonfigurowano {count} opłatę. | Skonfigurowano {count} opłaty. | Skonfigurowano {count} opłat.",
    summaryEmpty: "Utwórz opłaty opcjonalne (za rezerwację, za osobę lub za noc).",
    addButton: "Dodaj opłatę",
    empty: "Nie ma jeszcze opłat dodatkowych.",
    headers: {
      title: "Nazwa",
      method: "Sposób naliczania",
      value: "Wartość",
      visible: "Widoczna",
    },
    titlePlaceholder: "np. Opłata klimatyczna",
    removeTitle: "Usuń",
    hint: "Opłaty widoczne są pokazywane gościowi jako osobna pozycja przy finalizacji; pozostałe są doliczane do sumy.",
  },
  methods: {
    perStay: "Kwota za rezerwację",
    perNight: "Kwota za noc",
    perPerson: "Kwota za osobę",
    perPersonPerNight: "Kwota za osobę za noc",
    percent: "% sumy rezerwacji",
  },
  validation: {
    cleaningInvalid: "Opłata za sprzątanie musi być prawidłową liczbą dodatnią.",
    taxRange: "VAT musi mieścić się w przedziale od 0 do 100%.",
    chargeTitleRequired: "Każda opłata dodatkowa wymaga nazwy.",
    chargeValueInvalid: 'Wartość opłaty "{title}" jest nieprawidłowa.',
    chargePercentMax: 'Procent opłaty "{title}" nie może przekraczać 100%.',
  },
  toasts: {
    saveSuccess: "Opłaty dodatkowe zostały zapisane.",
    saveError: "Nie udało się zapisać opłat dodatkowych.",
  },
};
